<ng-container *ngIf="closingEntries$ | async as closingEntries">
    <div class="form-container" *ngIf="showForm">
        <ham-modal
            saveText="{{ 'aumico_reports_fcp_closing_save_entry' | i18next }}"
            saveIcon="assets/hamIcons/plus-outline.svg"
            (cancel)="cancel()"
            (save)="addClosingEntry()"
            title="{{ 'aumico_reports_fcp_closing_add_entry' | i18next }}"
        >
            <form [formGroup]="form" (ngSubmit)="addClosingEntry()">
                <div class="form-controls closingentry-form-controls">
                    <input
                        hamInput
                        label="{{ 'aumico_reports_fcp_closing_enter_amount' | i18next }}"
                        formControlName="amount"
                        type="number"
                        placeholder="{{ 'aumico_reports_fcp_closing_add_new_amount' | i18next }}"
                        (focus)="onFormFocused()"
                        (blur)="onFormBlur()"
                    />
                    <input
                        hamSearchDropDown
                        label="{{ 'aumico_reports_fcp_closing_select_debit' | i18next }}"
                        formControlName="debit"
                        placeholder="{{ 'aumico_reports_fcp_closing_add_new_debit' | i18next }}"
                        (focus)="onFormFocused()"
                        (blur)="onFormBlur()"
                        [options]="accounts"
                        [optionKeys]="['number', 'name']"
                        [returnKey]="'number'"
                    />
                    <input
                        hamSearchDropDown
                        label="{{ 'aumico_reports_fcp_closing_select_credit' | i18next }}"
                        formControlName="credit"
                        placeholder="{{ 'aumico_reports_fcp_closing_add_new_credit' | i18next }}"
                        (focus)="onFormFocused()"
                        (blur)="onFormBlur()"
                        [options]="accounts"
                        [optionKeys]="['number', 'name']"
                        [returnKey]="'number'"
                    />
                    <input
                        hamInput
                        label="{{ 'aumico_reports_fcp_closing_add_details' | i18next }}"
                        formControlName="text"
                        placeholder="{{ 'aumico_reports_fcp_closing_add_new_text' | i18next }}"
                        (focus)="onFormFocused()"
                        (blur)="onFormBlur()"
                    />
                </div>
            </form>
        </ham-modal>
    </div>
    <div *ngIf="closingEntries.length === 0 && lastYear" class="empty-closing-entries-container">
        {{ 'aumico_reports_fcp_closing_no_closing_entries_last_year' | i18next }}
    </div>
    <table class="closing-entries ham-table" *ngIf="!(closingEntries.length === 0 && lastYear)">
        <thead>
            <tr>
                <th>{{ 'aumico_reports_fcp_closing_details' | i18next }}</th>
                <th class="number-col">{{ 'aumico_reports_fcp_closing_amount' | i18next }}</th>
                <th class="account-col debit-col">{{ 'aumico_reports_fcp_closing_debit' | i18next }}</th>
                <th class="account-col credit-col">{{ 'aumico_reports_fcp_closing_credit' | i18next }}</th>
                <th *ngIf="!lastYear" class="done-col">
                    {{ 'aumico_reports_fcp_closing_done' | i18next }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let closingEntry of closingEntries; let i = index">
                <td>{{ closingEntry.text }}</td>
                <td class="number-col">{{ closingEntry.amount | finNumber }}</td>
                <td class="account-col debit-col">{{ closingEntry.debit | getTextForAccount : accounts }}</td>
                <td class="account-col credit-col">{{ closingEntry.credit | getTextForAccount : accounts }}</td>
                <td *ngIf="!lastYear" class="menu-col">
                    <div class="col-flex-wrapper">
                        <span class="action-button-wrapper">
                            <span
                                hamCheckbox
                                [checked]="closingEntry.booked"
                                (change)="markAsBooked($event.checked, closingEntry)"
                            ></span>
                        </span>

                        <div class="comment-menu" *ngIf="!lastYear">
                            <span
                                hamIconShapes
                                icon="assets/hamIcons/dots-vertical.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                [type]="'circle'"
                                (click)="toggleContextMenu($event, i)"
                            ></span>
                            <div
                                class="menu-flyout"
                                hamFlyout
                                *ngIf="isMenuOpenIndex === i"
                                (closeFlyout)="closeContextMenu()"
                                [position]="menuPosition"
                            >
                                <ul>
                                    <li (click)="updateClosingEntry(closingEntry)">
                                        <span class="ham-icon"> <i class="edit-icon"></i> </span
                                        ><span class="menu-item-text">{{
                                            'aumico_reports_fcp_closing_edit_entry' | i18next
                                        }}</span>
                                    </li>
                                    <li (click)="deleteClosingEntry(closingEntry)">
                                        <span class="ham-icon"> <i class="trash-icon"></i> </span
                                        ><span class="menu-item-text">{{
                                            'aumico_reports_fcp_closing_delete_entry' | i18next
                                        }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</ng-container>
